import $ from 'jquery';
import slick from 'slick-carousel';

// init
$( () => {
    const slickInit = ( e ) => {
    // init slick
    e.slick({
      arrows: false,
      swipeToSlide: true,
      rows: 0
    });
  }
  
  // let $slickElement = $('[data-slick]');
  // const images = document.querySelectorAll('.slider-wrapper')
  // const totalImages = images.length;
  // let currentIndex = 0;

  if ( $( '.slider-nav' ).length ) {
    let $slickElement = $( '.slider-nav' )
    slickInit( $slickElement );
  }

  if ( $( '.fp-slider' ).length ) {
    let $slickElement = $( '.fp-slider' )
    slickInit( $slickElement );
  }


  if ( $( '.slick-slider-block' ).length ) {
    let $slickElement = $( '.slick-slider-block' )
    let sliderPrev = $( '.slider-prev' )
    let sliderNext = $( '.slider-next' )

    // // nav slider left
    sliderPrev.on( 'click' , function() {
      let sliderParent = $( this ).parents( '.slick-slider-block' )
      let sliderSection = $( sliderParent ).parents( '.section-sliders' );
      
      sliderParent.slick('slickPrev');

      let slideBGColor = $( sliderParent.slick('getSlick').$slides[ sliderParent.slick('slickCurrentSlide') ] ).data( 'bg' )
      sliderSection.css( 'background-color', slideBGColor );
    });
    
    // // nav slider right
    $( sliderNext ).on( 'click' , function() {
      let sliderParent = $( this ).parents( '.slick-slider-block' )
      let sliderSection = $( sliderParent ).parents( '.section-sliders' );

      sliderParent.slick('slickNext');
      
      let slideBGColor = $( sliderParent.slick('getSlick').$slides[ sliderParent.slick('slickCurrentSlide') ] ).data( 'bg' )
      sliderSection.css( 'background-color', slideBGColor );  
      
    });
    
    slickInit( $slickElement );

  }

  // Background color change
  if( $( '.slider-block-showcase' ).length ) {
    let slickElement = $( '.slider-block-showcase' );
    let sliderSection = $( slickElement ).parents( '.section-sliders' );
    let slide = $( slickElement ).find( '.slide' )
    let slideBGColor = $( slide ).data( 'bg' )

    sliderSection.css( 'background-color', slideBGColor );
  }
})
